import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

interface Props {
  user: User | null | undefined
}

export default function MeAnonymousLabel({ user }: Props) {
  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      {user && <UserAvatar size="s48" user={user} />}
      <Text.Normal weight="medium">{i18n.t('surveys.form.responses.me_anonymous')}</Text.Normal>
    </Box>
  )
}
